import {
  ADD_CLIENT,
  DELETE_CLIENT,

  ADD_DRIVER,
  UPDATE_DRIVER,
  DELETE_DRIVER,

  RESET_STATE
} from './constants'


export const resetState = (client) => {
  return {
    type: RESET_STATE
  }
}

export const addClient = (client) => {
  return {
    type: ADD_CLIENT,
    client
  }
}

export const deleteClient = (id) => {
  return {
    type: DELETE_CLIENT,
    id
  }
}

export const addDriver = (first_name, last_name, email) => {
  return {
    type: ADD_DRIVER,
    first_name, last_name, email
  }
}

export const updateDriver = (id, field, inputValue) => {
  return {
    type: UPDATE_DRIVER,
    id, field, inputValue
  }
}

export const deleteDriver = (id) => {
  return {
    type: DELETE_DRIVER,
    id
  }
}



// WEBPACK FOOTER //
// ./src/components/DriversForm/actions.js